import axios from 'axios';
import _ from 'lodash';
import { push } from 'react-router-redux';
import {
  PLACE_ORDER,
  ERROR_PLACE_ORDER,
  REMOVE_BEARER,
  REMOVE_CVC,
  ORDER_BUTTON_CLICKED,
} from './types';

export const removeJwt = dispatch => {
  dispatch({ type: REMOVE_BEARER });
};

export const removeCVC = dispatch => {
  dispatch({ type: REMOVE_CVC });
};

export const onErrorPlaceOrder = (dispatch, path) => {
  dispatch({ type: ERROR_PLACE_ORDER });
  dispatch(push(path));
};

export const onSuccessPlaceOrder = (dispatch, orderNumber) => {
  dispatch({
    type: PLACE_ORDER,
    payload: orderNumber,
  });
  dispatch(push('/confirmation'));
};

export const orderButtonClicked = dispatch => {
  dispatch({
    type: ORDER_BUTTON_CLICKED,
  });
};

const placeOrder = ({
  customer,
  prescription,
  product,
  opaqueData,
  paymentProfileId,
  billingType,
  shipToType,
}) => (dispatch, getState) => {
  const { userInfo: { authentication } } = getState();

  orderButtonClicked(dispatch);

  /* [apk] todo: test isPristine or similar for addresses */
  const customerCopy = _.omit(
    customer,
    'firstName',
    'lastName',
    'phoneNumber',
    'practiceId'
  );
  customerCopy.billingAddress =
    customer.billingAddress || customer.shippingAddress;
  customerCopy.shippingAddress = customer.shippingAddress;

  // Make sure that customerCopy has the new value for email, so it can be sent upstream to DVM.  But only if it actually exists...
  const element = document.getElementById('email');
  if (
    typeof element !== 'undefined' &&
    element != null &&
    element.value.length > 0
  ) {
    customerCopy.emailAddress = element.value;
  }

  const postBody = {
    customer: {
      ...customerCopy,
    },
    payment: {
      paymentProfileId,
    },
    productChildGuid: product.guid,
    quantity: product.quantity,
    shippingMethodCode: product.defaultShippingMethodCode,
    patientGuid: prescription.patientGuid,
    flavorCode: product.flavorCode,
    prescriptionGuid: prescription.prescriptionGuid,
    billingType,
    shipToType,
    orderSource: 'FAST_FILL_SITE',
  };

  if (!opaqueData) {
    axios
      .post(`${APIENDPOINT}/order`, postBody, {
        headers: { bearer: authentication.replace('Bearer: ', '') },
      })
      .then(({ data: { orderNumber } }) => {
        onSuccessPlaceOrder(dispatch, orderNumber);
        removeJwt(dispatch);
        removeCVC(dispatch);
      })
      .catch(error => {
        const err = error.response.status;
        const path = `/${err}`;
        onErrorPlaceOrder(dispatch, path);
      });
  } else {
    postBody.payment.opaqueData = opaqueData;

    axios
      .post(`${APIENDPOINT}/order`, postBody, {
        headers: { bearer: authentication.replace('Bearer: ', '') },
      })
      .then(({ data: { orderNumber } }) => {
        onSuccessPlaceOrder(dispatch, orderNumber);
        removeJwt(dispatch);
        removeCVC(dispatch);
      })
      .catch(error => {
        const err = error.response.status;
        const path = `/${err}`;
        onErrorPlaceOrder(dispatch, path);
      });
  }
};

export default placeOrder;



// WEBPACK FOOTER //
// ./src/actions/order/placeOrder.js